import { useTranslation } from "react-i18next";
import { Link } from "@foris/avocado-suite";
import styles from "./proposalsAccess.module.scss";

interface ProposalsAccessProps {
  /** A link of the group has proposals waiting for the user's review. */
  hasIndicator: boolean;
  onOpen: () => void;
}

/**
 * "Ver solicitudes de cambio" in the group calendar header, with the orange dot that tells a
 * reviewer they have proposals to review. The parent only renders it for a user who can have
 * proposals.
 */
const ProposalsAccess = ({ hasIndicator, onOpen }: ProposalsAccessProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.proposalsAccess}>
      {hasIndicator && <span className={styles.proposalsAccess_indicator} data-indicator />}

      <Link inverse size="sm" iconRight="chevron-right" onClick={onOpen}>
        {t("group-proposals.access")}
      </Link>
    </div>
  );
};

export default ProposalsAccess;
